<template>
<div>
    <nav>
      <div class="navregular">
        <router-link to="/">Home</router-link>
        <!-- <a data-name="info" data-domain="chinesetypearchive" data-tld="com" href="#" class="cryptedmail" onclick="window.location.href = 'mailto:' + this.dataset.name + '@' + this.dataset.domain + '.' + this.dataset.tld"></a>-->
        <a href="https://forms.gle/fgGTa9P9vA1jVJMS7" target="_blank">Submit</a>
      </div>
      <div class="navmobile">
        <span class="menubutton" @click="menuButtonClicked"></span>
        <router-link to="/">The Chinese Type Archive</router-link>
        <span></span>
      </div>
    </nav>
    <!-- Will have different tables for Concepts, References, Typefaces -->
    <!-- PASS THE DATA INTO THE COMPONENTS BELOW -->
    <!-- May have to include some v-if v-else statement -->
    <RecordTypeface v-if="(this.$store.state.currentRecordType === 'typeface') && this.$store.state.fetchedTypefaceData" :recordtoshow=typeface />
    <RecordConcept v-if="(this.$store.state.currentRecordType === 'concept') && this.$store.state.fetchedConceptData" :recordtoshow=concept />
    <RecordResource v-if="(this.$store.state.currentRecordType === 'resource') && this.$store.state.fetchedResourceData" :recordtoshow=resource />

</div>
</template>

<script>
//import axios from 'axios'

import RecordConcept from '@/components/RecordConcept.vue'
import RecordTypeface from '@/components/RecordTypeface.vue'
import RecordResource from '@/components/RecordResource.vue'

export default {
  name: 'RecordViewSide',
  props: {
  },
  components: {
    RecordConcept,
    RecordTypeface,
    RecordResource
  },
  computed: { //Computed calculates data dynamically
      typefaces: function(){
          return this.$store.state.fetchedTypefaces
      },
      concepts: function(){
          return this.$store.state.fetchedConcepts
      },
      resources: function(){
          return this.$store.state.fetchedResources
      },
      typeface: function() {    //treat 'typeface' like a variable; can be used just like a piece of data
        //Check to see if recordtype is typeface
        if(this.$store.state.currentRecordType === 'typeface' && this.$store.state.fetchedTypefaceData){
          
          //Check to see if params value is null/empty/undefined; if so, then use the default/current recordid value
          if(this.$route.params.recordid == null){
            var temparray = this.typefaces.filter(item => { 
                return item.recordid === this.$store.state.currentTypefaceRecordID
              })
              return temparray[0]
          }else {
            //If params value is not empty, then filter on dataset based on the recordid
            //Returns an temp array that is the result of filtering the typeface record dataset
            temparray = this.typefaces.filter(item => { 
              return item.recordid === this.$route.params.recordid 
            })
            //If the a value is returned, then show it
            if(temparray.length > 0){
              //Filtering the typeface record dataset returns an object is an array of 1 array. We are going to return the inside array
              //Update currentTypefaceRecordID with updateTypefaceRecordID
              this.$store.commit('updateTypefaceRecordID', this.$route.params.recordid )
              return temparray[0]
            }else {
              //If no value is returned (meaning that the id is bogus), then use default/current recordid value
              temparray = this.typefaces.filter(item => { 
                return item.recordid === this.$store.state.currentTypefaceRecordID
              })
              return temparray[0]
            }
          }
        }else { //If recordtype is not typeface, then return empty
          return {}
        }    
      },
      concept: function() {    //treat 'concept' like a variable; can be used just like a piece of data
        //Check to see if recordtype is concept
        if(this.$store.state.currentRecordType === 'concept' && this.$store.state.fetchedConceptData){
          //Check to see if params value is null/empty/undefined; if so, then use the default/current recordid value
          if(this.$route.params.recordid == null){
            var temparray = this.concepts.filter(item => { 
                return item.recordid === this.$store.state.currentConceptRecordID
              })
              return temparray[0]
          }else {
            //If params value is not empty, then filter on dataset based on the recordid
            //Returns an temp array that is the result of filtering the concept record dataset
            temparray = this.concepts.filter(item => { 
              return item.recordid === this.$route.params.recordid 
            })
            //If the a value is returned, then show it
            if(temparray.length > 0){
              //Filtering the concept record dataset returns an object is an array of 1 array. We are going to return the inside array
              //Update currentConceptRecordID with updateConceptRecordID
              this.$store.commit('updateConceptRecordID', this.$route.params.recordid )
              return temparray[0]
            }else {
              //If no value is returned (meaning that the id is bogus), then use default/current recordid value
              temparray = this.concepts.filter(item => { 
                return item.recordid === this.$store.state.currentConceptRecordID
              })
              return temparray[0]
            }
          }
        }else { //If recordtype is not concept, then return empty
          return {}
        }      
      },
      resource: function() {    //treat 'resource' like a variable; can be used just like a piece of data
        //Check to see if recordtype is resource
        if(this.$store.state.currentRecordType === 'resource' && this.$store.state.fetchedResourceData){
          //Check to see if params value is null/empty/undefined; if so, then use the default/current recordid value
          if(this.$route.params.recordid == null){
            var temparray = this.resources.filter(item => { 
                return item.recordid === this.$store.state.currentResourceRecordID
              })
              return temparray[0]
          }else {
            //If params value is not empty, then filter on dataset based on the recordid
            //Returns an temp array that is the result of filtering the resource record dataset
            temparray = this.resources.filter(item => { 
              return item.recordid === this.$route.params.recordid 
            })
            //If the a value is returned, then show it
            if(temparray.length > 0){
              //Filtering the resource record dataset returns an object is an array of 1 array. We are going to return the inside array
              //Update currentResourceRecordID with updateResourceRecordID
              this.$store.commit('updateResourceRecordID', this.$route.params.recordid )
              return temparray[0]
            }else {
              //If no value is returned (meaning that the id is bogus), then use default/current recordid value
              temparray = this.resources.filter(item => { 
                return item.recordid === this.$store.state.currentResourceRecordID
              })
              return temparray[0]
            }
          }
        }else { //If recordtype is not resource, then return empty
          return {}
        }
      },
      

  },
  methods: {
    menuButtonClicked(){
      if(this.$store.state.menuOpened){
        this.$store.state.menuOpened=false;
      }else {
        this.$store.state.menuOpened=true;
      }
    }
  }
  
}
</script>

<style>
</style>
